<template>
	<b-form @submit.prevent>
		<b-row>
			<b-col v-if="!hideStatus" cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Appeal Status" label-for="status" label-cols-lg="4">
					<b-form-select
						name="status"
						v-model="filters.status"
						:disabled="disabled"
						:options="appealStatuses"
						text-field="name"
						value-field="value"
						:class="{ highlight: isUsed.status}"
						@input="highlight('status')"
					>
						<template #first>
							<option :value="null">(All)</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col>
			<b-col v-if="!hideInprocess" cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Appeal Status" label-for="inprocess" label-cols-lg="4">
					<b-form-select
						name="inprocess"
						v-model="inprocess"
						:disabled="flase"
						class="inprocess"
						
					>
					    <option value="In Process">In Process</option>
					</b-form-select>
				</b-form-group>
            </b-col>
			<b-col v-if="!hideClose" cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Appeal Status" label-for="close" label-cols-lg="4">
					<b-form-select
						name="close"
						v-model="close"
						:disabled="false"
						class="open"
						
					>
					    <option value="Close">Closed</option>
					</b-form-select>
				</b-form-group>
            </b-col>
			<b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Case Status" label-for="case_status" label-cols-lg="4">
				<b-form-select
					name="case_status"
					v-model="filters.case_status"
					:disabled="disabled"
					:options="caseStatuses"
					text-field="name"
					value-field="value"
					:class="{ highlight: isUsed.case_status }"
					@input="highlight('case_status')"
				>
				<template #first>
					<option :value="null">(All)</option>
				</template>
				</b-form-select>
				</b-form-group>
			</b-col>
			<b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Current Level" label-for="appeal_level_id" label-cols-lg="4">
					<b-form-select
						name="appeal_level_id"
						v-model="filters.appeal_level_id"
						:disabled="disabled || filters.is_rebill !== null"
						:options="appealLevels"
						value-field="id"
						text-field="name"
						:class="{ highlight: isUsed.appeal_level_id }"
						@input="highlight('appeal_level_id')"
					>
						<template #first>
							<option :value="null">(All)</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col>
			<b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label-cols-lg="4" label="Facility" label-for="facility_id">
					<search-input 
						name="facility_id"
						v-model="filters.facility_id"
						:key="filters.facility_id"  
						:class="{ highlight: filters.facility_id && filters.facility_id.trim() !== '' }"
						@input="(value) => filters.facility_id = value !== '' ? value : null"
						:disabled="disabled"
					/>
				</b-form-group>
			</b-col>
			<b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label-cols-lg="4" label="Division" label-for="division">
					<b-form-select
						name="division" 
						v-model="filters.division" 
						:disabled="disabled"
						:options="divisonOptions"
						value-field="division"
						text-field="division"
						:class="{ highlight: isUsed.division }"
						@input="highlight('division')"
					>
						<template #first>
							<option :value="null">(All)</option>
							<!-- <option :value="null">(None)</option> -->
						</template>
					</b-form-select>
				</b-form-group>
			</b-col>
			<!-- <b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Appeal Type" label-for="appeal_type_id" label-cols-lg="4">
					<b-form-select
						name="appeal_type_id"
						v-model="filters.appeal_type_id"
						:disabled="disabled"
						:options="appealTypes"
						value-field="id"
						text-field="name"
					>
						<template #first>
							<option :value="null">(All)</option>
							<option :value="false">(None)</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col> -->
			<b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Denial Type" label-for="denial_type_id" label-cols-lg="4">
					<b-form-select
						name="denial_type_id"
						v-model="filters.denial_type_id"
						:disabled="disabled"
						:options="denialTypes"
						value-field="id"
						text-field="name"
						:class="{ highlight: isUsed.denial_type_id }"
						@input="highlight('denial_type_id')"
					>
						<template #first>
						
							<option :value="null">(All)</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col>
			<!-- <b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Facility" label-for="facility_id" label-cols-lg="4">
					<b-form-select
						name="facility_id"
						v-model="filters.facility_id"
						:disabled="disabled"
						:options="facilities"
						value-field="id"
						text-field="name"
					>
						<template #first>
							 
							<option :value="null">(All)</option>
							<option v-if="!facilities.length > 0" :value="null" disabled>No facilities added.</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col> -->
			<!-- <b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Visit Number" label-for="visit_number" label-cols-lg="4">
					<b-form-input
						type="text"
						name="visit_number"
						v-model="filters.visit_number"
						:disabled="disabled"
						lazy
					/>
				</b-form-group>
			</b-col> -->
			<b-col v-if="!hideAgency" cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Agency" label-for="agency_id" label-cols-lg="4">
					<b-form-select
						name="agency_id"
						v-model="filters.agency_id"
						:disabled="disabled"
						:options="agencies"
						value-field="id"
						text-field="name"
						:class="{ highlight: isUsed.agency_id }"
						@input="highlight('agency_id')"
					>
						<template #first>
							<option :value="null">(All)</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col>
			<b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Insurance Provider" label-for="insurance_provider_id" label-cols-lg="4">
					<b-form-select
						name="insurance_provider_id"
						v-model="filters.insurance_provider_id"
						:disabled="disabled"
						:options="insuranceProviders"
						value-field="id"
						text-field="name"
						:class="{ highlight: isUsed.insurance_provider_id }"
						@input="highlight('insurance_provider_id')"
					>
						<template #first>
							<option :value="null">(All)</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col>
			<!-- <b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Insurance Type" label-for="insurance_type_id" label-cols-lg="4">
					<b-form-select
						name="insurance_type_id"
						v-model="filters.insurance_type_id"
						:disabled="disabled"
						:options="insuranceTypes"
						value-field="id"
						text-field="name"
					>
						<template #first>
							
							<option :value="null">(All)</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col>
			<b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Insurance Plan" label-for="insurance_plan" label-cols-lg="4">
					<b-form-input name="insurance_plan" v-model="filters.insurance_plan" :disabled="disabled" lazy />
				</b-form-group>
			</b-col>
			<b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Insurance Number" label-for="insurance_number" label-cols-lg="4">
					<b-form-input
						name="insurance_number"
						v-model="filters.insurance_number"
						:disabled="disabled"
						lazy
					/>
				</b-form-group>
			</b-col> -->
			<!-- <b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Outcome" label-for="case_outcome_id" label-cols-lg="4">
					<b-form-select
						name="case_outcome_id"
						v-model="filters.case_outcome_id"
						:disabled="disabled"
						:options="caseOutcomes"
						value-field="id"
						text-field="name"
					>
						<template #first>
							
							<option :value="null">(All)</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col> -->
			<!-- <b-col v-if="!hideAssignedTo" cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Assigned To" label-for="assigned_to" label-cols-lg="4">
					<b-form-select
						name="assigned_to"
						v-model="filters.assigned_to"
						:disabled="disabled"
						:options="activeUsers"
						value-field="id"
						text-field="full_name"
						:class="{ highlight: isUsed.assigned_to }"
						@input="highlight('assigned_to')"
					>
						<template #first>
							<option :value="null">(All)</option>
							<option :value="false">(Unassigned)</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col> -->
			
			<b-col v-if="!hideAssignedTo" cols="12" sm="6" lg="6" xl="4">
				<b-form-group label-cols-lg="4" label="Assigned To" label-for="assigned_to">
					<b-form-select
					v-model="filters.assigned_to"
					class="w-100"
					:class="{ highlight: filters.assigned_to !== null }"
					@change="highlight"
					:disabled="disabled"
					>
					<option :value="null">(All)</option>
					<option :value="false">(Unassigned)</option>
					<option
						v-for="user in activeUsers"
						:key="user.id"
						:value="user.id"
					>
						{{ user.full_name }} <span v-if="!user.active"><strong>(Inactive)</strong></span>
					</option>
					</b-form-select>
				</b-form-group>
			</b-col>

			<b-col v-if="!hideUnassinged" cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Assigned To" label-for="unassigned" label-cols-lg="4">
					<b-form-select
						name="unassigned"
						v-model="unassigned"
						:disabled="false"
						class="inprocess"
					>
						
							<option :value="Unassigned">(Unassigned)</option>
				
					</b-form-select>
				</b-form-group>
			</b-col>

			<!-- <b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Admit Date" label-for="admit_date" label-cols-lg="4">
					<b-form-input name="admit_date" type="date" v-model="filters.admit_date" :disabled="disabled" />
				</b-form-group>
			</b-col>
			<b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Discharge Date" label-for="discharge_date" label-cols-lg="4">
					<b-form-input
						name="discharge_date"
						type="date"
						v-model="filters.discharge_date"
						:disabled="disabled"
					/>
				</b-form-group>
			</b-col> -->
			<b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Defendable" label-for="defendable" label-cols-lg="4">
					<b-form-select
						name="defendable"
						v-model="filters.defendable"
						:disabled="disabled"
						:options="defendableOptions"
						value-field="value"
						text-field="name"
						:class="{ highlight: isUsed.defendable }"
						@input="highlight('defendable')"
					>
						<template #first>
							<option :value="null">(All)</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col>
			<b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Priority" label-for="priority" label-cols-lg="4">
					<b-form-select
						name="priority"
						v-model="filters.priority"
						:disabled="disabled"
						:options="priorityOptions"
						:class="{ highlight: isUsed.priority }"
						@input="highlight('priority')"
					/>
				</b-form-group>
			</b-col>
			<b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Is Rebill" label-for="is_rebill" label-cols-lg="4">
					<b-form-select
						name="is_rebill"
						v-model="filters.is_rebill"
						:disabled="disabled"
						:options="RebillOption"
						:class="{ highlight: isUsed.is_rebill }"
						@input="highlight('is_rebill')"
					/>
				</b-form-group> 
			</b-col>
			<b-col cols="12" sm="6" lg="6" xl="4">
		  <b-form-group label-cols-lg="4" label="Begin DOS" label-for="admit_date">
			<b-form-input
			  name="admit_date"
			  type="date"
			  v-model="filters.admit_date"
			  :class="{ highlight: filters.admit_date !== null }"
			  @input="highlight"
			  :disabled="disabled"
			/>
		  </b-form-group>
		</b-col>
		<b-col cols="12" sm="6" lg="6" xl="4">
		  <b-form-group label-cols-lg="4" label="End DOS" label-for="discharge_date">
			<b-form-input
			  name="discharge_date"
			  type="date"
			  v-model="filters.discharge_date"
			  :class="{ highlight: filters.discharge_date !== null }"
			  @input="highlight"
			  :disabled="disabled"
			/>
		  </b-form-group>
		</b-col>
		<b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label-cols-lg="4" label="Chain" label-for="chain_name">
					<search-input
						name="id"
						v-model="filters.chain_name"
						:key="filters.chain_name" 
						:class="{ highlight: filters.chain_name && filters.chain_name.trim() !== '' }"
						@input="(value) => filters.chain_name = value !== '' ? value : null"
						:disabled="disabled"
						/>
				</b-form-group>
		</b-col>
		<b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label-cols-lg="4" label="Appeal ID" label-for="id">
					<search-input
						name="id"
						v-model="filters.id"
						:key="filters.id" 
						:class="{ highlight: filters.id && filters.id.trim() !== '' }"
						@input="(value) => filters.id = value !== '' ? value : null"
						:disabled="disabled"
						/>
				</b-form-group>
		</b-col>
		</b-row>
	</b-form>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
import axios from "axios";

export default {
	name: "AppealFilters",
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					status: null,
					case_status : null,
					denial_type_id: null,
					facility_id: null,
					visit_number: null,
					insurance_provider_id: null,
					insurance_type_id: null,
					insurance_plan: null,
					insurance_number: null,
					appeal_level_id: null,
					appeal_type_id: null,
					case_outcome_id: null,
					assigned_to: null,
					admit_date: null,
					discharge_date: null,
					defendable: null,
					audit_reviewer_id: null,
					agency_id: null,
					unable_to_complete: null,
					division: null,
					is_rebill:null,
				};
			},
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		hideAgency: {
			type: Boolean,
			default: false,
		},
		hideAssignedTo: {
			type: Boolean,
			default: false,
		},
		hideStatus: {
			type: Boolean,
			default: false,
		},
		hideInprocess: {
			type: Boolean,
			default: true,
		},
		hideClose: {
			type: Boolean,
			default: true,
		},
		hideUnassinged: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		filters: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
		...mapGetters({
			activeUsers: "users/active",
			agencies: "agencies/active",
			appealStatuses: "appeals/statuses",
			appealTypes: "appealTypes/all",
			appealLevels: "appealLevels/all",
			caseStatuses: "cases/statuses",
			caseTypes: "caseTypes/all",
			caseOutcomes: "caseOutcomes/all",
			defendableOptions: "appeals/defendableOptions",
			denialTypes: "denialTypes/all",
			facilities: "facilities/active",
			insuranceProviders: "insuranceProviders/active",
			insuranceTypes: "insuranceTypes/all",
		}),
	},
	methods: {
		highlight(field) {
			this.isUsed[field] = this.filters[field] !== null && this.filters[field] !== "" && this.filters[field] !== "All";
        },
		async getAllDivision() {
			const url = '/client/api/facilities/getAllDivision';
			
			// Perform an axios GET request
			axios.get(url)
				.then(response => {
					this.divisonOptions = response.data.divisions;
				})
				.catch(error => {
					// Handle any errors
					console.error('Error fetching divisions:', error);
				});
		}
    },
	data() {
		return {
			inprocess : "In Process",
			unassigend: "(Unassigned)",
			close: 'Close',
			priorityOptions: [
				{ text: "(All)", value: null },
				{ text: "Yes", value: true },
				{ text: "No", value: false },
			],
			RebillOption: [
				{ text: "(All)", value: null },
				{ text: "Yes", value: true },
				{text: "No", value:false}
			],
			isUsed: {
				status: false,
				case_status: false,
				appeal_level_id:false,
				defendable:false,
				assigned_to: false,
				insurance_provider_id: false,
				agency_id: false,
				priority: false,
				id: false,
				facility_id:false,
				admit_date:false,
				discharge_date: false,
				division: false,
				denial_type_id : false,
			},
			divisonOptions:[],
		};
	},
	mounted() {
		this.getAllDivision();		
	},
};
</script>

<style>
.highlight {
  border: 2px solid #007bff; /* Example: blue border */
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5); /* Optional: blue shadow */
}
.inprocess {
  border: 2px solid #007bff; /* Example: blue border */
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5); /* Optional: blue shadow */
  color:black;
}
</style> 